import api from './api';

export const credencialService = {
  /**
   * Gerar credenciais em PDF para múltiplas matrículas
   */
  gerarCredenciais: async (matriculasIds) => {
    try {
      const response = await api.post('/matriculas/credenciais', {
        matriculasIds
      }, {
        responseType: 'blob', // Importante para receber PDF
        timeout: 120000, // 2 minutos para geração de PDF
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Criar URL do blob
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // Criar link de download
      const link = document.createElement('a');
      link.href = url;
      link.download = `credenciais-${Date.now()}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Limpar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Credenciais geradas com sucesso!'
      };
    } catch (error) {
      console.error('Erro ao gerar credenciais:', error);
      return {
        success: false,
        message: error.response?.data?.error || 'Erro ao gerar credenciais'
      };
    }
  }
};

export default credencialService;
